import { render, staticRenderFns } from "./tuandco-image-menu.vue?vue&type=template&id=24e6fb56&"
import script from "./tuandco-image-menu.vue?vue&type=script&lang=ts&"
export * from "./tuandco-image-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports